import React from 'react'

const ModalConnect = ({ handleChange, values, _forgotPassword, _signIn }) => {
    return (
        <div className="modal fade" id="connectModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="connectModal">Créer un compte</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className='mt-3'>
                            <input type="email" className='form-control border-0 rounded-pill shadow p-2' placeholder="Email" values={values.email} name='email' onChange={handleChange} />
                        </div>
                        <div className='mt-3'>
                            <input type="password" className='form-control border-0 rounded-pill shadow p-2' placeholder="Mot de passe" values={values.password} name='password' onChange={handleChange} />
                        </div>
                        <div className='text-center mt-2' style={{cursor:'pointer'}} onClick={() => _forgotPassword(values.email)}>Mot de passe oublié</div>
                        <div className='text-center my-4 '>
                            <button 
                                type='button'
                                className='btn btn-outline my-3 shadow rounded-pill' 
                                data-bs-toggle="modal" 
                                data-bs-target="#connectModal"
                                style={{ cursor:'pointer' }}
                                disabled={values.email && values.password ? false : true}
                                onClick={() => _signIn(values.email, values.password)}
                            >Se connecter</button> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalConnect